import { ANIMATION_IDENTIFIERS, DrawAnimationMechanicConfig } from '@Animation/types'
import { SpaceInvadersNumberSelector } from './number-selector'
import { SpaceInvadersNumber } from './number'
import { PLUS_3_CONFIG } from '../add-on-extra-draw/plus-3/config'
import { NoBackground } from '../base/background'
import { MI_MULTIPLIER_WHEEL_CONFIG } from '../add-on-multiplier/michigan-kicker/wheel/config'
import { preLoadAssets } from '.'
import { SpaceInvadersTextureLoader } from './texture-loader'

export const SpaceInvadersConfig: DrawAnimationMechanicConfig = {
  appSettings: {
    backgroundBaseColor: '#061127',
    backgroundGlowColor: '#FFFFFFFF',
    backgroundUrl: '/animations/space-invaders/background.png',
  },
  numberSelector: SpaceInvadersNumberSelector,
  background: NoBackground,
  foreground: null,
  kenoNumber: SpaceInvadersNumber,
  multiplierAnimationConfig: MI_MULTIPLIER_WHEEL_CONFIG,
  assetPreloader: preLoadAssets,
  extraDrawAnimationConfig: PLUS_3_CONFIG(ANIMATION_IDENTIFIERS.SPACE_INVADERS),
  textureLoader: SpaceInvadersTextureLoader,
}
